__turbopack_context__.v({
  "selectTransparent": "select-module-scss-module__HrZQnG__selectTransparent",
});
